import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Modal, ModalHeader, Form, Label, Input } from "reactstrap";
import { LoginResponse } from "../../models";
import { wglcsApiService } from "../../services/WglcsApiService";
import { Password } from "primereact/password";
import validator from "validator";
import ExtendedToast from '../../views/alert/Toast'
import { Ripple } from "primereact/ripple";
import EventEmitter, { Events } from "../../services/eventemitter";
import { t } from "i18next";

interface ChangePasswordModalState {
    oldPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    userData: LoginResponse;
    oldPasswordErrorText: string;
    newPasswordErrorText: string;
    reTypePasswordErrorText: string,
    openSnackBar: boolean,
    severity: string,
    responseMsg: string
}

interface ChangePasswordModalProps {
    onClose: () => void;
}
var text;
const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ onClose }) => {
    const [state, setState] = useState<ChangePasswordModalState>(() => {
        const userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        return {
            userData,
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            oldPasswordErrorText: "",
            newPasswordErrorText: "",
            reTypePasswordErrorText: "",
            openSnackBar: false,
            severity: "",
            responseMsg: ""
        };
    }
    );


    const PasswordValidator = useCallback(() => {
        let isError = false;

        if (state.oldPassword == "" || state.oldPassword == null) {
            isError = true;
            text = t("* Required")
            setState((prevState) => ({ ...prevState, oldPasswordErrorText: text }));
        }

        if (state.oldPassword === state.newPassword) {
            isError = true;
            text = t("errorMessage.samePassword")
            setState((prevState) => ({
                ...prevState,
                newPasswordErrorText: text,
            }));
        }

        if (
            validator.isStrongPassword(state.newPassword, {
                minLength: 8,
                minUppercase: 1,
                minLowercase: 1,
                minNumbers: 1,
                minSymbols: 1,
                maxLength: 20,
            })
        ) {
        } else {
            isError = true;
            text = t("errorMessage.wrongPassword")
            setState((prevState) => ({ ...prevState, newPasswordErrorText: text }));
        }

        if (state.confirmNewPassword.length === 0) {
            isError = true;
            text = t("* Required")
            setState((prevState) => ({ ...prevState, reTypePasswordErrorText: text }));
        }

        if (state.confirmNewPassword != state.newPassword) {
            isError = true;
            text = t("errorMessage.notMatch")
            setState((prevState) => ({
                ...prevState,
                reTypePasswordErrorText: text,
            }))
        }

        if (state.oldPassword != "" && state.oldPassword != state.userData.userLoginData.userPassword) {
            isError = true
            text = t("errorMessage.wrongoldPassword")
            setState((prevState) => ({
                ...prevState,
                oldPasswordErrorText: text,
            }))
        }


        return isError;
    }, [state]);

    const updatePassword = useCallback(async () => {
        setState((prevState) => ({
            ...prevState,
            reTypePasswordErrorText: "",
            oldPasswordErrorText: "",
            newPasswordErrorText: ""
        }))

        if (PasswordValidator()) {
            return;
        }

        const obj = {
            userId: state.userData.userLoginData.userId,
            userName: state.userData.userLoginData.username,
            newPassword: state.newPassword,
        };

        await wglcsApiService.updateUserPassword(obj);
        onClose()
        text =t("toast.Passwordchanged")
        EventEmitter.emit(Events.PasswordChange, text)
        setTimeout(() => {
            localStorage.clear();
            window.location.reload();
        }, 1000);

        setState((prevState) => ({
            ...prevState,
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
        }));

    }, [PasswordValidator, state]);


    const header = useMemo(() => <h6 style={{ fontSize: "16px" }}>{t('changePasswordComponent.Pick-password')}</h6>, []);
    const footer = useMemo(() => <React.Fragment>

        <p style={{ fontSize: '14px;', fontWeight: '700;' }} className="p-mt-1 mb-1 pt-0 pb-0">{t('changePasswordComponent.PasswordSuggestions')}Suggestions</p>
        <ul className="p-pl-2 p-ml-2 p-mt-0 pb-0 mb-0" style={{ lineHeight: "1.2", fontSize: '12px;' }}>
            <li>{t('changePasswordComponent.SuggestionCharacter')}</li>
            <li>{t('changePasswordComponent.SuggestionSymbol')}</li>
            <li>{t('changePasswordComponent.SuggestionLength')}</li>
        </ul>
    </React.Fragment>, []);

    const handleClose = () => {
        setState((prevState) => ({
            ...prevState,
            openSnackBar: false,
        }))
    }

    return (
        <>
            <div className="text-center">
                <Modal className="change-pw-modal" isOpen={true}>
                    <ModalHeader>
                        {t('changePasswordComponent.header')}
                        <button
                            type="button"
                            onClick={() => onClose()}
                            data-dismiss="modal"
                            aria-label="Close"
                            className="close p-ripple"
                        >
                            <Ripple /> <span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>

                    <Form className="custom-form" style={{ padding: "20px" }}>
                        <div className="form-group">
                            <Label for="exampleEmail">{t('changePasswordComponent.Old Password')}</Label>
                            <Password
                                className="form-control"
                                toggleMask
                                onChange={(e) =>
                                    setState((prevState) => ({
                                        ...prevState,
                                        oldPasswordErrorText: "",
                                        oldPassword: e.target.value
                                    }))
                                }
                                value={state.oldPassword}
                                feedback={false}
                            />
                            <span style={{ color: "red" }}>{state.oldPasswordErrorText}</span>
                        </div>
                        <div className="form-group">
                            <Label for="examplePassword">{t('changePasswordComponent.New Password')}</Label>
                            <Password
                                id="examplePassword"
                                className="form-control"
                                toggleMask
                                header={header}
                                footer={footer}
                                onChange={(e) =>
                                    setState((prevState) => ({
                                        ...prevState,
                                        newPasswordErrorText: "",
                                        newPassword: e.target.value
                                    }))}
                                value={state.newPassword}
                            />
                            <span style={{ color: "red" }}>{state.newPasswordErrorText}</span>
                        </div>
                        <div className="form-group">
                            <Label for="examplePassword">{t('changePasswordComponent.ConfirmPassword')}</Label>
                            <Password
                                className="form-control"
                                toggleMask
                                header={header}
                                footer={footer}
                                onChange={(e) =>
                                    setState((prevState) => ({
                                        ...prevState,
                                        reTypePasswordErrorText: "",
                                        confirmNewPassword: e.target.value
                                    }))}
                                value={state.confirmNewPassword}
                            />
                            <span style={{ color: "red" }}>{state.reTypePasswordErrorText}</span>

                        </div>
                        <div className="form-group">
                            <button className="wgbtn p-ripple" onClick={updatePassword} type="button"><Ripple />{t('Update')}</button>
                            <button className="wgclear-btn p-ripple" type="button" onClick={() => onClose()}><Ripple />{t('wg-buttons.Cancel')}</button>
                        </div>
                    </Form>
                </Modal>
            </div>

            <ExtendedToast
                open={state.openSnackBar}
                severity={state.severity}
                handleClose={handleClose}
                message={state.responseMsg}
            />
        </>

    );

}

export default ChangePasswordModal